module.exports = __webpack_public_path__ + "static/img/code-3.93a6c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/code-3.png
// module id = lLiy
// module chunks = 0